import { mc } from '@lss/common/game/characters/MC';
import Game from '../../src/shell/Game';
import ImageClass from "../../src/shell/Image";
import Question from '../../src/shell/Questions';
import { jump } from '../../src/shell/jump';
import { chris } from '../characters/Chris';
import { merry } from '../characters/Merry';
import { images } from "./images";
import { V5EmilyNight } from './V5';
import { V6ChrisMerryEnd } from './V6_ChrisMerry';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';

export const V5ChrisRandomGirl = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_0, { transition: true });
    await mc.set((properties) => {
        properties.merryStatus = "natural";
    });
    mc.think(`There he is.`);
    mc.think(`Why did he call me if he is sitting with someone?`);
    ImageClass.setImage(images.v5.ChrisMerry_1);
    chris.talk(`Hey! ${mc.name}!`, { method: "Shouting" });
    mc.think(`I guess it's time to find out.`);
    ImageClass.setImage(images.v5.ChrisMerry_2);
    chris.talk(`Merry, meet ${mc.name}, he is one of my closest friends!`);
    mc.think(`Of course I am...`);
    chris.talk(`Keep him company while I'll go do some stuff, ok?`);
    merry.talk(`I guess...`);
    return jump(V5ChrisRandomGirlTalk, "V5ChrisRandomGirlTalk");
};

export const V5ChrisRandomGirlTalk = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_3);
    mc.talk(`Hey, I'm ${mc.name}.`);
    merry.talk(`Hi.`);
    ImageClass.setImage(images.v5.ChrisMerry_4);
    mc.talk(`So...`);
    mc.talk(`How do you and Chris know each other?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`From here...`);
    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};

export const V5ChrisRandomGirlTalk2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);

    await mc.setQuestion(new Question({ text: `...`, options: { think: true, array: "v5MerryConversationArr" }, key: `v5MerryConversation` })
        .option({ title: `What do you do in life?`, key: `whatDoYouDoInLife`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("whatDoYouDoInLife") })
        .option({ title: `What are you drinking?`, key: `whatAreYouDrinking`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("whatAreYouDrinking") })
        .option({ title: `Do you live nearby?`, key: `doYouLeaveNearby`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("doYouLeaveNearby") })
        .option({ title: `How old are you?`, key: `howOldAreYou`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("howOldAreYou"), show: (Question.globalAnswers.v5MerryConversationArr?.length || 0) > 2 })
        .option({ title: `What's your favorite color?`, key: `whatsYourFavoriteColor`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("whatsYourFavoriteColor"), show: (Question.globalAnswers.v5MerryConversationArr?.length || 0) > 2 })
        .option({ title: `Do you want to ask me something?`, key: `doYouWantToAskSomething`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("doYouWantToAskSomething"), show: (Question.globalAnswers.v5MerryConversationArr?.length || 0) > 2 })
        .option({ title: `Say nothing`, key: `sayNothing`, hide: Question.globalAnswers.v5MerryConversationArr?.includes("sayNothing"), })
        .option({ title: `Leave`, key: `leave` }));


    if (Question.globalAnswers.v5MerryConversation === "whatDoYouDoInLife") {
        return jump(V5ChrisRandomGirlTalk2_1, "V5ChrisRandomGirlTalk2_1");

    } else if (Question.globalAnswers.v5MerryConversation === "whatAreYouDrinking") {
        return jump(V5ChrisRandomGirlTalk2_2, "V5ChrisRandomGirlTalk2_2");

    } else if (Question.globalAnswers.v5MerryConversation === "doYouLeaveNearby") {
        return jump(V5ChrisRandomGirlTalk2_3, "V5ChrisRandomGirlTalk2_3");

    } else if (Question.globalAnswers.v5MerryConversation === "howOldAreYou") {
        return jump(V5ChrisRandomGirlTalk2_4, "V5ChrisRandomGirlTalk2_4");

    } else if (Question.globalAnswers.v5MerryConversation === "whatsYourFavoriteColor") {
        return jump(V5ChrisRandomGirlTalk2_5, "V5ChrisRandomGirlTalk2_5");

    } else if (Question.globalAnswers.v5MerryConversation === "doYouWantToAskSomething") {
        return jump(V5ChrisRandomGirlTalk2_6, "V5ChrisRandomGirlTalk2_6");

    } else if (Question.globalAnswers.v5MerryConversation === "sayNothing") {
        return jump(V5ChrisRandomGirlTalk2_7, "V5ChrisRandomGirlTalk2_7");

    } else if (Question.globalAnswers.v5MerryConversation === "leave") {
        return jump(V5ChrisRandomGirlLeave, "V5ChrisRandomGirlLeave");

    }

    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");

};


export const V5ChrisRandomGirlTalk2_1 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`What do you do in life?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`Study to become a nurse.`);
    mc.talk(`Nice, do you like it?`);
    merry.talk(`Sometimes.`);
    mc.talk(`Why do you continue studying it if you sometimes don't like it?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`Because I started.`);
    ImageClass.setImage(images.v5.ChrisMerry_5);
    mc.talk(`Alright.`);
    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};


export const V5ChrisRandomGirlTalk2_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`What are you drinking?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`A cocktail.`);
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`I can see it, but what flavor?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`I don't know, Chris made it for me.`);
    mc.talk(`I can see an orange.`);
    merry.talk(`Yes.`);

    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};


export const V5ChrisRandomGirlTalk2_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`Do you live nearby?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`No.`);
    ImageClass.setImage(images.v5.ChrisMerry_5);
    mc.talk(`Oh, so why did you choose to come here?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`I was around.`);
    mc.talk(`Oh, what were you doing here?`);
    merry.talk(`Passing through.`);

    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};


export const V5ChrisRandomGirlTalk2_4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`How old are you?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`Twenty-two.`);
    mc.think(`She is a bit older than me but I don't think she gives a fuck.`);

    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};
export const V5ChrisRandomGirlTalk2_5 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`What's your favorite color?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`Blue.`);
    mc.talk(`Really? I would've guessed red.`);
    merry.talk(`Why?`);
    mc.talk(`Wild guess.`);

    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};

export const V5ChrisRandomGirlTalk2_6 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.talk(`Do you want to ask me something?`);

    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`Not really.`);

    ImageClass.setImage(images.v5.ChrisMerry_5);
    mc.talk(`Alright.`);


    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};

export const V5ChrisRandomGirlTalk2_7 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_7);
    mc.think(`..`);
    ImageClass.setImage(images.v5.ChrisMerry_5);
    mc.think(`...`);
    ImageClass.setImage(images.v5.ChrisMerry_4);
    mc.think(`I don't think I'm gonna win the silence game against her.`);

    return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
};


export const V5ChrisRandomGirlLeave = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_6);
    mc.think(`I don't have time for this.`);
    return jump(V5ChrisRandomGirlLeave_Chris, "V5ChrisRandomGirlLeave_Chris");
};



export const V5ChrisRandomGirlLeave_Chris = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_9);
    if (Game.seenScenarios.includes(`V5ChrisRandomGirlLeave_Chris`)) {

        return jump(V5ChrisRandomGirlLeave_ChrisTalk_2, "V5ChrisRandomGirlLeave_ChrisTalk_2");
    }

    chris.talk(`${mc.name}! Where are you going?`);
    mc.talk(`Are you serious with this girl?`);
    ImageClass.setImage(images.v5.ChrisMerry_8);
    chris.talk(`She really is something. Isn't she?`);
    mc.talk(`She is something...`);
    if (Game.seenScenarios.includes(`V6ChrisMerry`)) {

        mc.talk(`I don't think this deal of yours is gonna work.`);
        chris.talk(`Why what's the problem?`);
    } else {
        mc.talk(`Why did you tell me to come here anyway?`);
        ImageClass.setImage(images.v5.ChrisMerry_10);
        chris.talk(`To meet Merry of course.`);
        chris.talk(`Have you forgotten about our deal already?`);
        chris.talk(`I've told you that I'll send girls your way if I have the chance.`);
        mc.talk(`I didn't forget. But I don't think it's going to work with her.`);
        chris.talk(`Why what's the problem?`);
    }

    if (!Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_1`) &&
        !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_2`) &&
        !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_3`) &&
        !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_4`) &&
        !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_5`) &&
        !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_6`)) {

        return jump(V5ChrisRandomGirlLeave_ChrisDidntTalk, "V5ChrisRandomGirlLeave_ChrisDidntTalk");
    }
    return jump(V5ChrisRandomGirlLeave_ChrisTalk_2, "V5ChrisRandomGirlLeave_ChrisTalk_2");
};


export const V5ChrisRandomGirlLeave_ChrisDidntTalk = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_10);
    mc.talk(`I'm not feeling it.`);
    ImageClass.setImage(images.v5.ChrisMerry_9);
    chris.talk(`Have you tried talking to her?`);
    ImageClass.setImage(images.v5.ChrisMerry_10);
    mc.talk(`I did, she didn't seem to want to talk.`);
    chris.talk(`That's just how she is.`);
    return jump(V5ChrisRandomGirlLeave_ChrisDidntTalk_Question, "V5ChrisRandomGirlLeave_ChrisDidntTalk_Question");
};

export const V5ChrisRandomGirlLeave_ChrisDidntTalk_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_9);
    await chris.setQuestion(new Question({ text: `Give her another chance, what have you got to lose?`, options: { think: false }, key: `v5DidntTalkGaveMerryAnotherChance` })
        .option({ title: `Fine`, key: true })
        .option({ title: `I'd rather leave`, key: false }));


    if (Question.globalAnswers.v5DidntTalkGaveMerryAnotherChance) {
        ImageClass.setImage(images.v5.ChrisMerry_6, { transition: true });
        mc.talk(`I'm back.`);
        merry.talk(`...`);

        return jump(V5ChrisRandomGirlTalk2, "V5ChrisRandomGirlTalk2");
    } else {

        return jump(V5ChrisRandomGirlLeave_ChrisDidntTalk_Leave, "V5ChrisRandomGirlLeave_ChrisDidntTalk_Leave");
    }

};

export const V5ChrisRandomGirlLeave_ChrisDidntTalk_Leave = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_10);
    mc.talk(`Nah, I'm good.`);
    mc.talk(`Thanks anyway.`);
    ImageClass.setImage(images.v5.ChrisMerry_9);
    chris.talk(`Seriously?`);
    ImageClass.setImage(images.v5.ChrisMerry_10);
    mc.talk(`Yes...`);
    chris.talk(`Ok bro, don't forget that I've tried!`);
    mc.talk(`I won't.\nCya Chris.`);
    if (Game.seenScenarios.includes(`V6ChrisMerry`)) {

        return jump(V6ChrisMerryEnd, "V6ChrisMerryEnd");
    }

    chris.talk(`Bye.`);
    mc.think(`Time to get back home.`);
    return jump(V5EmilyNight, "V5EmilyNight");
};

export const V5ChrisRandomGirlLeave_ChrisTalk_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_10);

    if (Game.seenScenarios.includes(`V5ChrisRandomGirlLeave_Chris`) && !Game.seenScenarios.includes(`V6ChrisMerry`)) {
        chris.talk(`What happened now?`);
        if (!Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_1`) &&
            !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_2`) &&
            !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_3`) &&
            !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_4`) &&
            !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_5`) &&
            !Game.seenScenarios.includes(`V5ChrisRandomGirlTalk2_6`)) {

            mc.talk(`I don't know, I just left again... I guess I'm a moron.`);
            chris.talk(`Haha.`);
        } else {

            mc.talk(`I tried talking to her, she is fucking boring.`);
        }

        mc.talk(`Why did you call me anyway? It's a complete waste of time.`);
        ImageClass.setImage(images.v5.ChrisMerry_9);
    }
    if (!Game.seenScenarios.includes(`V5ChrisRandomGirlLeave_Chris`)) {
        mc.talk(`Have you really tried talking to her?`);
        ImageClass.setImage(images.v5.ChrisMerry_9);
        chris.talk(`Of course not, I just call her when I'm bored and I want to fuck.`);
    }
    chris.talk(`She is the easiest girl that I know. So I figured I'll throw you a bone.`);
    ImageClass.setImage(images.v5.ChrisMerry_10);
    mc.talk(`Easy? That girl? Are you fucking with me?`);
    chris.talk(`I'm as serious as a heart attack.`);
    chris.talk(`You don't need to talk to her, just tell her you want to fuck.`);
    mc.talk(`I genuinely believe you are fucking with me.`);
    ImageClass.setImage(images.v5.ChrisMerry_8);
    chris.talk(`Haha, I'm not man.`);
    chris.talk(`Try it, what's the worst that can happen?`);
    mc.talk(`She looks insane, she might murder me in my sleep.`);
    chris.talk(`Haha, go ahead and try it, you can thank me later.`);
    mc.talk(`Wait, is she a prostitute?`);

    return jump(V5ChrisRandomGirlLeave_ChrisTalk_2_Question, "V5ChrisRandomGirlLeave_ChrisTalk_2_Question");
};

export const V5ChrisRandomGirlLeave_ChrisTalk_2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_8);
    await chris.setQuestion(new Question({ text: `No, just a slut.`, options: { think: false }, key: `v5GaveMerryAnotherChance` })
        .option({ title: `Ok, wish me luck`, key: true })
        .option({ title: `I'll pass this time`, key: false }));


    if (Question.globalAnswers.v5GaveMerryAnotherChance) {

        return jump(V5ChrisRandomGirl_ReturnToMerry, "V5ChrisRandomGirl_ReturnToMerry");
    } else {

        return jump(V5ChrisRandomGirl_LeaveFinal, "V5ChrisRandomGirl_LeaveFinal");
    }
};


export const V5ChrisRandomGirl_ReturnToMerry = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_8);
    mc.talk(`Ok, wish me luck.`);
    ImageClass.setImage(images.v5.ChrisMerry_4, { transition: true });
    mc.talk(`Hey, I'm back.`);
    mc.talk(`Merry.`);
    mc.talk(`Wanna fuck?`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    merry.talk(`Ok.`);
    ImageClass.setImage(images.v5.ChrisMerry_7);
    mc.talk(`...`);
    mc.think(`Really...`);
    mc.talk(`Let's go to the restroom.`);
    merry.talk(`Ok.`);
    ImageClass.setImage(images.v5.ChrisMerry_13, { transition: true });
    mc.think(`...`);

    ImageClass.setImage(images.v5.ChrisMerry_14);
    mc.think(`Is she waiting for me to tell her what to do?`);
    mc.talk(`How about a blowjob?`);
    merry.talk(`Ok.`);
    ImageClass.setImage(images.v5.ChrisMerry_15);
    mc.think(`She was.`);
    ImageClass.setImage(images.v5.ChrisMerry_16);
    mc.think(`I think that's the most meaningless conversation a person can ever have, but who cares?`);
    ImageClass.setImage(images.v5.ChrisMerry_15);
    mc.think(`She doesn't talk much, but she knows what she is doing.`);
    ImageClass.setImage(images.v5.ChrisMerry_16);
    mc.think(`...`);
    ImageClass.setImage(images.v5.ChrisMerry_17, { wait: true });
    ImageClass.setImage(images.v5.ChrisMerry_18, { wait: true });
    ImageClass.setImage(images.v5.ChrisMerry_19, { wait: true });
    mc.think(`You know it's getting real when a girl gathers her hair.`);


    ImageClass.setImage(images.v5.Anim_ChrisMerry.poster);
    mc.think(`Let's see what she is worth.`);
    ImageClass.setAnimation(images.v5.Anim_ChrisMerry);
    mc.talk(`Fuck!`);
    mc.talk(`Fuck. Keep going.`);
    mc.think(`She was so good.`);
    mc.think(`Good to know her mouth was good for something.`);
    mc.talk(`Get up, I wanna to fuck you.`);

    return jump(V5ChrisRandomGirl_ReturnToMerry_Question, "V5ChrisRandomGirl_ReturnToMerry_Question");
};

export const V5ChrisRandomGirl_ReturnToMerry_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_22, { transition: true });
    await merry.setQuestion(new Question({ text: `Not in the pussy.`, options: { think: false }, key: `v5FuckedMerryAss` })
        .option({ title: `Fuck her in the ass`, key: true })
        .option({ title: `Leave`, key: false }));


    if (Question.globalAnswers.v5FuckedMerryAss) {

        return jump(V5ChrisRandomGirl_ReturnToMerry_Question_Ass, "V5ChrisRandomGirl_ReturnToMerry_Question_Ass");
    } else {

        return jump(V5ChrisRandomGirl_ReturnToMerry_Question_Leave, "V5ChrisRandomGirl_ReturnToMerry_Question_Leave");
    }
};


export const V5ChrisRandomGirl_ReturnToMerry_Question_Ass = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_22);
    mc.talk(`Even better.`);
    ImageClass.setImage(images.v5.ChrisMerry_23);
    mc.think(`She put so much saliva on my cock that it slid right in without a problem.`);
    ImageClass.setImage(images.v5.ChrisMerry_24);
    mc.think(`Fuck! Her ass is so tight.`);
    ImageClass.setImage(images.v5.ChrisMerry_25);
    mc.talk(`Push against me.`);
    ImageClass.setImage(images.v5.ChrisMerry_28);
    mc.talk(`More.`);
    ImageClass.setImage(images.v5.ChrisMerry_25);
    mc.talk(`More!`);
    ImageClass.setImage(images.v5.ChrisMerry_28, { wait: true });
    ImageClass.setImage(images.v5.ChrisMerry_25, { wait: true });
    ImageClass.setImage(images.v5.ChrisMerry_26);
    mc.talk(`Fuck!`);
    mc.think(`I came so deep inside her ass I don't think it will come out, fuck.`);
    ImageClass.setImage(images.v5.ChrisMerry_27);
    mc.talk(`Let's get out of here.`);
    await endReplay(replayScenesList.v5MerryMCToilet);
    return jump(V5ChrisRandomGirl_Finish, "V5ChrisRandomGirl_Finish");
};

export const V5ChrisRandomGirl_Finish = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_8, { duration: 0.6 });
    await mc.set((properties) => {
        properties.merryStatus = "anal";
    });

    chris.talk(`So??? I saw you leaving with her, how was it?`);
    mc.talk(`I'm not sure.`);
    mc.talk(`It felt good, but that girl doesn't moan.`);
    mc.talk(`So I have no idea if she liked it or not.`);
    chris.talk(`Tell me about that.`);
    mc.talk(`What's her deal anyway? Does she even enjoy it?`);
    chris.talk(`I bet she does. Why would she do that otherwise?`);
    mc.talk(`Don't ask me, she is way too weird for me.`);
    chris.talk(`Who cares? It's not like you are going to marry her.`);
    mc.talk(`Marry Merry? Haha, no way.`);
    mc.think(`Why does she keep staring at me?`);
    chris.talk(`I hope that you see that I mean business.`);

    mc.talk(`I do.\nI just don't have any girls to spare at the moment.`);
    chris.talk(`No pressure, I am a patient person.`);
    mc.talk(`I'll get going.`);
    chris.talk(`Cya.`);

    if (Game.seenScenarios.includes(`V6ChrisMerry`)) {

        return jump(V6ChrisMerryEnd, "V6ChrisMerryEnd");
    }
    mc.think(`Time to get back home.`);

    return jump(V5EmilyNight, "V5EmilyNight");
};


export const V5ChrisRandomGirl_ReturnToMerry_Question_Leave = async (): Promise<any> => {
    await endReplay();
    ImageClass.setImage(images.v5.ChrisMerry_22);
    await mc.set((properties) => {
        properties.merryStatus = "blowjob";
    });
    mc.talk(`Nah, I changed my mind.`);
    merry.talk(`Ok.`);
    mc.talk(`Let's get out of here.`);
    ImageClass.setImage(images.v5.ChrisMerry_10, { transition: true });
    chris.talk(`Back so fast?`);
    mc.talk(`Yeah... I changed my mind, I ain't going to fuck her.`);
    chris.talk(`Weird... Did you get your dick sucked at least?`);
    mc.talk(`Yeah...`);
    chris.talk(`She is good isn't she?\nAt least her mouth is good for something.`);
    mc.talk(`Haha, yeah I guess.`);
    chris.talk(`Anyway, I hope that you saw that I mean business.`);
    chris.talk(`Maybe you'd like the next girl I'll introduce to you.`);
    mc.talk(`I hope so.`);
    chris.talk(`Cya dude.`);
    mc.talk(`Bye.`);
    if (Game.seenScenarios.includes(`V6ChrisMerry`)) {

        return jump(V6ChrisMerryEnd, "V6ChrisMerryEnd");
    }
    mc.think(`Time to get back home.`);
    return jump(V5EmilyNight, "V5EmilyNight");
};

export const V5ChrisRandomGirl_LeaveFinal = async (): Promise<any> => {
    ImageClass.setImage(images.v5.ChrisMerry_10);
    mc.talk(`I'll pass.`);
    chris.talk(`Why?`);
    mc.talk(`I guess she is too weird for me.`);
    chris.talk(`So what?`);
    mc.talk(`Not my thing...`);
    chris.talk(`Suit yourself! I tried.`);
    mc.talk(`I appreciate it.`);
    mc.talk(`Cya Chris.`);
    chris.talk(`Bye.`);
    if (Game.seenScenarios.includes(`V6ChrisMerry`)) {

        return jump(V6ChrisMerryEnd, "V6ChrisMerryEnd");
    }
    mc.think(`Time to get back home.`);
    return jump(V5EmilyNight, "V5EmilyNight");
};


